export enum MitIdErrorCodes {
	// get widget
	widgetConfigLoadFailed = 400955,
	widgetInitFailed = 400956,
	widgetInitUnhandledError = 400957,
	widgetUrlNotValid = 400958,

	// login
	userWithCPRNotRegistered = 400964,
	multipleUsersWithCPRDetected = 400965,
	userDataDoesNotMatch = 400966,
	userValidationUnhandledError = 400967,
	unsupportedGrantType = 400119,

	// login + resolve user info
	tokenExchangeConfigLoadFailed = 400959,
	externalProviderError = 400960,
	authResponseNotValid = 400961,
	tokenExchangeRequestFailed = 400962,
	tokenExchangeResponseNotValid = 400963,
}
